$mol_app_hello $mol_view
	sub /
		<= Name $mol_string
			hint <= name_hint \Name
			value? <=> name? \
		<= Greeting $mol_view
			sub /
				<= greeting \
